enum CreateAirdropsSignTransactionStep {
  CreateEditionDistributor = "CreateEditionDistribuor",
  MintNft = "MintNft",
  MintNftAndCreateEditionDistributor = "MintNftAndCreateEditionDistributor",
}

export default CreateAirdropsSignTransactionStep;
